export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://Service.sharkify.ai/',
  baseAuthApiUrl: 'https://Technology.sharkify.ai/',
  INSTAGRAM_CLIENT_ID: '1118401823126619',
  INSTAGRAM_CLIENT_SECRET: '88d453ad93c5352adb806b66b2be2bb4',
  INSTAGRAM_REDIRECT_URI: 'https://sharkify.ai/Dashboard/SocialMediaAccounts'
}; 